export { BvlFormInputComponent as BvlFormInput } from './form-input.component';
export { BvlFormInputModule } from './form-input.module';